import React from "react";


function Overviewchart() {
    return (
        

            <div className="card mb-3 pb-3">
                <div className="card-body">
                    <h5 className="card-body"> Inpatient VS Outpatient</h5>

                </div>
            </div>

    

    )
}

export default Overviewchart;